import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, } from 'react-bootstrap';
import './Navbar.css';
import moment from 'moment';
import { Icon, } from '@payit/cool-web-ui-library';
import { OPEN_TAB_EVENT, } from '../../actions/tab';
import { tabKeys, } from '../../modules/Constants';
import store from '../../store';
import AuthenticationService from '../../service/AuthenticationService';

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false, };
  }

  getNavItemsComponent() {
    const { navItems = [], dispatch, } = this.props;
    const servicesTabIndex = 0;
    return (
      <>
        {navItems.map((navItem) => {
          if (navItem.name !== tabKeys.SERVICE_MANAGEMENT_KEY) {
            return (
              <div className="dropdown" key={navItem.name}>
                <button className="dropbtn" type="button">{`${navItem.name}`}</button>
                <div className="dropdown-content">
                  {navItem.items.map((tab) => {
                    if (tab.isNavActive) {
                      return (
                        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
                        <label
                          htmlFor={tab.key}
                          key={tab.key}
                          className="dropdown-item"
                          onClick={() => {
                            dispatch({
                              type: OPEN_TAB_EVENT,
                              selectedTab: tab,
                            });
                          }}
                        >
                          {`${tab.tabName}`}
                        </label>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            );
          }

          return (
            <div className="dropdown" key={navItem.name}>
              <button
                className="dropbtn"
                type="button"
                onClick={() => {
                  dispatch({
                    type: OPEN_TAB_EVENT,
                    selectedTab: navItem.items[servicesTabIndex],
                  });
                }}
              >
                {`${navItem.name}`}
              </button>
            </div>
          );
        })}
      </>
    );
  }

  handleKeyPress(event, servicesNavIndex, servicesTabIndex) {
    if (event.keyCode === 13) {
      const { navItems = [], dispatch, } = this.props;
      dispatch({
        type: OPEN_TAB_EVENT,
        selectedTab: navItems[servicesNavIndex].items[servicesTabIndex],
      });
    }
  }

  logout() {
    AuthenticationService.logout();
  }

  render() {
    const { expanded, } = this.state;
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <span className="navbar-brand">PayIt - Athos</span>
        <button
          className={`navbar-toggler${expanded ? '' : ' collapsed'}`}
          type="button"
          onClick={() => { this.setState((state) => ({ expanded: !state.expanded, })); }}
          aria-controls="navbarNavDropdown"
          aria-expanded={expanded}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <Collapse in={expanded}>
          <div className="navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">{this.getNavItemsComponent()}</ul>
          </div>
        </Collapse>
        <div className="session-info">
          <div>
            <span>Session expires {moment(store.getState().auth.authentication.expireDate).fromNow()}</span>
            <span className='divider'>{'  |  '}</span>
            <span
              role="button"
              tabIndex={0}
              className='logout'
              onClick={() => { this.logout(); }}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  this.logout();
                }
              }}
            >
              Log out <span className='icon'><Icon iconKey='CLOSE' display='inline-block' size={2} alt='Log Out' /></span>
            </span>
          </div>
        </div>
      </nav>
    );
  }
}

Navbar.defaultProps = {
  navItems: undefined,
};

Navbar.propTypes = {
  navItems: PropTypes.instanceOf(Array),
  dispatch: PropTypes.instanceOf(Function).isRequired,
};

export default Navbar;
